export default function identity(x) {
  return x;
}


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/utils/identity.js
// module id = 173
// module chunks = 0